import { Injectable, signal } from '@angular/core';
import { TopBarItem } from 'src/app/interfaces/top-bar-item';
import { assert } from 'src/app/utils/assert.util';

@Injectable({
  providedIn: 'root'
})
export class TopBarService {
  items = signal<TopBarItem[]>([]);
  activeItem = signal<TopBarItem | null>(null);
  constructor() { }

  setItems(items: TopBarItem[]) {
    this.items.set(items);
    this.activeItem.set(items[0]);
  }

  selectActiveItem(key: string) {
    const item = this.items().find(i => i.key === key);
    assert(item, `No top bar item found with key: ${key}`);
    this.activeItem.set(item);
  }
}
